export default __webpack_public_path__ + "static/media/logo04.8e1d4ca3.svg";